module.exports = __webpack_public_path__ + "img/logo_nt.d54cf0e8.png";